import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';
import { toast } from 'react-toastify';
import Button from '../Button';
import styles from './SocialButtons.module.scss';
import { FB_SIGN_IN_URL } from './variables';

export interface FacebookAuthResponse {
    authResponse: {
        accessToken: string;
        data_access_expiration_time: number;
        expiresIn: number;
        grantedScopes: string;
        graphDomain: string;
        signedRequest: string;
        userId: string;
    };
    status: 'connected';
}

interface FacebookButtonProps {
    appId: string;
    title?: string;
}

const FacebookButton: FC<FacebookButtonProps> = ({ appId, title = 'Facebook' }) => {
    const signInFacebook = async () => {
        await (window as any).FB.login(
            (authRes: FacebookAuthResponse) => {
                const accessToken = authRes?.authResponse?.accessToken;
                const grantedScopes = authRes?.authResponse?.grantedScopes;

                if (accessToken && grantedScopes) {
                    (window as any).FB.api(
                        '/me/accounts',
                        'GET',
                        {
                            access_token: accessToken
                        },
                        (res: any) => {
                            console.log('🚀 > res:', res);
                        }
                    );
                } else {
                    toast.error('You cancelled get Facebook pages request or did not fully authorize');
                }
            },
            {
                scope: ['email', 'public_profile'],
                return_scopes: true,
                enable_profile_selector: true
            }
        );
    };
    return (
        <Link href={FB_SIGN_IN_URL(appId)} className="w-full">
            <Button className={classNames(styles.social_btn, styles.facebook_btn)}>
                <Image alt="Facebook's logo" src="/svgs/facebook.svg" width={20} height={20} />
                Sign in with Facebook
            </Button>
        </Link>
    );
};

export default FacebookButton;
